
/*
Add Patterns here
Comma is needed after each row, no comma after the last row

Large patterns on hold:
  ["Nature Palms Miami","NATURE_PALMS_MIAMI.svg"],
  ["Neapolitan","NEAPOLITAN-_HAWAIIAN.svg"],
  ["Pineapple Pepper","PINEAPPLE-PEPPER_HAWAIIAN.svg"],
*/ 



const patternInfo = 
[ 
  ["Bandana","BANDANA.svg"],
["Aurora Burn","aurora-burn", "8dc8e8,0057b8,bb29bb"],
  ["Big Cat","BIG-CAT-HAWAIIAN.svg"],
  ["Bird of Paradise","BIRD-PARADISE-HAWAIIAN.svg"],
["Brain Coral","BRAIN_CORAL.svg"],
["Cloud Wind","CLOUDWIND.svg"],
["Cox & Dix","COXNDIX.svg"],
["Cuban Camo","CUBAN_CAMO.svg"],
["Da Slikest","DA_SLIKEST.svg"],
["Dad Hawaiian","DAD_HAWAIIAN.svg"],
["Daisy Fields","DAISY_FIELDS.svg"],
["Deco Cinco","DECO_CINCO.svg"],
["Deco Dos","DECO_DOS.svg"],
["Deco Quatro","DECO_QUATRO.svg"],
["Deco Tres","DECO_TRES.svg"],
["Deco Uno","DECO_UNO.svg"],
["Desert Amber Glow","desert-amber-glow", "85714d,f2a900,efd19f,ff6900"],
["Desert Camo","DESERT_CAMO.svg"],
  ["Dotti Camo","DOTTI-CAMO.svg"],
["Dotti Camo #2","DOTTY_CAMO.svg"],
["Freaky Tiki Outline","FREAKY_TIKI_OUTLINE.svg"],
["Freaky Tiki Stackup","FREAKY_TIKI_STACKUP.svg"],
["Gator Bait","GATOR_BAIT.svg"],
["Geo Camo","GEO_CAMO.svg"],
["Grammas Wall","GRAMMAS_WALL.svg"],
["Gray Wolf Camo","GRAY_WOLF_CAMO.svg"],
["Gullible","GULLIBLE.svg"],
["Hawaiian","SOLID-OUTLINE-HAWAIIAN.svg"],
["Hawaiian Island Aloha","HAWAIIAN_ISLAND_ALOHA.svg"],
["Lavender Elevation","LAVENDER_ELEVATION.svg"],
["Merica","USAFlag.svg"],
["Misty Mountain","MISTY_MTN.svg"],
["Mud Crackle","MUD_CRACKLE.svg"],
["Orchid","ORCHID.svg"],
["Oregon Trail","oregon-trail", "0076a8,888b8d,ffae62,ff6a13"],
["Palm Stack","PALM_STACK.svg"],
["Palms","PALMS.svg"],
["Phillipines Sailing Map","PHILLIPINES_SAILING_MAP.svg"],
["Pine Floor","PINE_FLOOR.svg"],
["Pink Palms","PINK_PALMS.svg"],
["Plaidiator","PLAIDIATOR.svg"],
["Plumeria","PLUMERIA.svg"],
["Plumarias","PLUMERIAS.svg"],
["Prince Leopard","PRINCE_LEOPARD.svg"],
["Puro Azteca","PURO_AZTECA.svg"],
["Slant Camo","SLANT_CAMO.svg"],
["Snow Camo","SNOW_CAMO.svg"],
["Splatter Camo","SPLATTER_CAMO.svg"],
["Splatter Drips","SPLATTER_DRIPS.svg"],
["Sunrise or Sunset","sunrise-or-sunset", "fedd00,fe5000,bb29bb,0085ca"],
["Supacaz","SUPACAZ.svg"],
["Swinger","SWINGER.svg"],
["The Shed","THE_SHED.svg"],
["Tiki Bar","TIKI_BAR.svg"],
["Tribal","TRIBAL.svg"],
["Trippy Light","TRIPPY_LIGHT.svg"],
["Trippy","TRIPPY.svg"],
["Waterwind","WATERWIND.svg"],
["Western Aloha","WESTERN_ALOHA.svg"],
["Woodgrain Again","WOODGRAIN_AGAIN.svg"],
["Woodland Camo","WOODLAND_CAMO.svg"],
["Woodland Digi Camo","WOODLAND_DIGI_CAMO.svg"],
["Woodgrain","WOOGRAIN.svg"]
 
];

